<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col">
        <h1 class="text-center py-4">Backup</h1>
        <div class="container">
          <table class="table">
            <thead class="thead-dark text-center">
              <tr>
                <th scope="col">#</th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr>
                <td>1</td>
                <td>Base de datos</td>
                <td>
                  <span
                    class="btn text-uppercase btn-treid"
                    @click="handleSaveDB()"
                    ><span class="material-icons"> cloud_download </span></span
                  >
                </td>
              </tr>
              <tr>
                <td>2 <a id="downloadAnchorElem"></a></td>
                <td>Stack Errors</td>
                <td>
                  <span
                    class="btn text-uppercase btn-treid"
                    @click="handleSaveStackError()"
                    ><span class="material-icons"> cloud_download </span></span
                  >
                  <span
                    class="btn text-uppercase btn-treid ml-1"
                    @click="handleShowStackError()"
                    ><span class="material-icons"> plagiarism </span></span
                  >
                </td>
              </tr>
              <tr>
                <td>3</td>
                <td>Stack Operations</td>
                <td>
                  <span class="btn text-uppercase btn-treid"
                    ><span class="material-icons"> cloud_download </span></span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ModalTable
      :visible="modalTable.visible"
      v-if="modalTable.isLoad"
    />
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import ModalTable from "@/components/modals/ModalTable.vue";
import { mapState } from "vuex";
import Api2 from "@/tools/Api2";

export default {
  name: "AdminBackUp",
  data() {
    return {
      modalTable: {
        isLoad: false,
        visible: false,
        table: {},
      },
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {
    handleShowStackError() {
      Api2("back-up")
        .get("stack-errors")
        .then((res) => {
          
          this.modalTable.table = {
            stackErrors: res.data.split("\n").slice(0,50),
          };
          
          this.modalTable.visible = true;
          this.modalTable.isLoad = true;
        });
    },
    handleSaveDB() {
      Api2("back-up")
        .get("all")
        .then((res) => {
          let date = new Date();
          let dataStr =
            "data:text/json;charset=utf-8," +
            encodeURIComponent(JSON.stringify(res));
          let dlAnchorElem = document.getElementById("downloadAnchorElem");
          dlAnchorElem.setAttribute("href", dataStr);
          dlAnchorElem.setAttribute(
            "download",
            `TreidBlue [${date.getDate()}-${
              date.getMonth() - 1
            }-${date.getFullYear()}].json`
          );
          dlAnchorElem.click();
        });
    },
    handleSaveStackError() {
      Api2("back-up")
        .get("stack-errors")
        .then((res) => {

          let dataStr =
            "data:text/json;charset=utf-8," + encodeURIComponent(res.data);
          let dlAnchorElem = document.getElementById("downloadAnchorElem");
          dlAnchorElem.setAttribute("href", dataStr);
          dlAnchorElem.setAttribute("download", `TreidBlue [StackErrors].log`);
          dlAnchorElem.click();
        });
    },
  },
  components: {
    NavbarMain,
    NavbarAdmin,
    ModalTable,
  },
  created: function () {

  },
};
</script>